
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import {classesApi} from '@/api';

import moment from 'moment';
@Component
export default class Batch_Validity extends Vue {
    @Prop({default: {}}) studentList?: any;
    @Emit('closeModal') private closeModal() {}
    @Emit('refreshStudentList') private refreshStudentList() {}
    //===================================data区域begin
    form: any = {
        userIds: [],
        isDefaultExpire: true,
        validStartTime: '',
        expireTime: ''
    };
    formRules: any = {
        validStartTime: [
            {
                required: true,
                message: '请选择有效期',
                trigger: 'change'
            }
        ]
    };
    // 学校有效期
    schoolValidityStart: string = '';
    schoolValidityEnd: string = '';
    // 有效期选择组件是否显示
    isSchoolValidity: boolean = true;
    //===================================data区域end
    //===================================computed区域begin
    //===================================computed区域end
    //===================================methods区域begin
    // 清空表单数据
    refreshForm() {
        this.form.isDefaultExpire = true;
        this.form.validStartTime = '';
        this.form.expireTime = '';
        this.form.userIds = [];
    }
    handleCancel() {
        this.refreshForm();
        this.$emit('closeModal');
    }
    handleOk() {
        console.log(this.studentList);
        let isValid = false;
        let me = this;
        (me.$refs.Form as any).validate((valid: any) => {
            if (!valid) {
                return;
            }
            isValid = true;
            if (isValid) {
                for (let i = 0; i < me.studentList.length; i++) {
                    me.form.userIds.push(me.studentList[i]._id);
                }
                console.log(me.form);
                classesApi.batchValidity({
                    context: me,
                    data: me.form,
                    success(data: any, parameters: any) {
                        me.$message.success(`操作成功！已重设${me.studentList.length}名学生的账号有效期`);
                        me.$emit('refreshStudentList');
                        me.handleCancel();
                    },
                    error(error: any, message: string, parameters: any) {
                        me.$message.error(message);
                    }
                });
            }
        });
    }
    // 账号有效期
    changeRadio(e: any) {
        // console.log(e);
        if (e.target.value == 'custom') {
            this.isSchoolValidity = false;
            this.form.isDefaultExpire = false;
            this.form.validStartTime = null;
            this.form.expireTime = null;
        } else {
            this.isSchoolValidity = true;
            this.form.isDefaultExpire = true;
            // 有效期同学校有效期
            this.form.validStartTime = this.schoolValidityStart;
            this.form.expireTime = this.schoolValidityEnd;
        }
    }
    disabledDate(current: any) {
        return (current && current < moment(this.schoolValidityStart)) || current > moment(this.schoolValidityEnd).add(1, 'day');
    }
    // 账号有效期
    changeDate(dates: any) {
        // console.log(dates);
        if (dates[0]) {
            this.form.validStartTime = dates[0].format('YYYY/MM/DD');
            if (moment(dates[1].format('YYYY/MM/DD')) > moment(this.schoolValidityEnd)) {
                this.form.expireTime = this.schoolValidityEnd;
                dates[1] = moment(this.schoolValidityEnd);
            } else {
                this.form.expireTime = dates[1].format('YYYY/MM/DD');
            }
        } else {
            this.form.validStartTime = null;
            this.form.expireTime = null;
        }
        // 手动校验有效期
        (this.$refs.Form as any).validateField('validStartTime', (valid: any) => {
            if (!!valid === false) {
                console.log('error...........');
                return;
            }
        });
    }
    //===================================methods区域end
    created() {
        // console.log(this);
        let schoolInfo: any = JSON.parse(window.localStorage.getItem('schoolInfo') as string);
        if (schoolInfo) {
            this.schoolValidityStart = schoolInfo.validStartTime;
            this.schoolValidityEnd = schoolInfo.expireTime;
        }
    }
    mounted() {
        this.isSchoolValidity = true;
        this.form.validStartTime = this.schoolValidityStart;
        this.form.expireTime = this.schoolValidityEnd;
    }
}
